export default __webpack_public_path__ + "static/mLSolutionBanner-39772eb0d9b7a972c435d9ae0140b881.svg";